<template>
  <div ref="cadriPage"
      class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="isAddNewGenerator"
                class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="isEditGenerator"
                class="crud-title">
              <translate>UPDATE</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form ref="dynamicForm"
                              :inputs="prepareInputs(elements)"
                              :relacionamentos="elements[0].relacionamentos"
                              :model="elements[0].dadosForm"
                              :interface="elements[0].nmInterface"
                              form-class="form dynamic"
                              @composition-button-click="onCompositionButtonClick" />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div v-if="forms[0] && forms[0].buttons.length > 0"
        class="row full-width q-col-gutter-lg justify-center q-pt-lg">
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width"
              color="grey-7"
              @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div v-for="(button, i) in forms[0].buttons"
          :key="i"
          class="col-lg-2 col-md-3">
        <q-btn class="full-width"
              color="info"
              @click="actionButton(button)">
          <q-icon v-if="button.icon"
                  :name="button.icon"
                  size="18px"
                  class="position-icon-filter" />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <composition-multi-form-modal v-show="showMultiFormBoundResidues"
                                  ref="boundResidue"
                                  titleTopBar="ADD_MORE_RESIDUE"
                                  addOneMoreItemButtonLabel="RESIDUE"
                                  :form="formConfig"
                                  :model="elements[0].dadosForm"
                                  :composicaos="elements[0].dadosForm.boundResidues"
                                  :nr-linha-selecionada="nrLinhaSelecionada"
                                  :fl-main-crud-in-change="isEditGenerator"
                                  :fl-composicao-alteracao="editMode"
                                  :non-changeable-fields="nonChangeableFields"
                                  :afterPerformItems="afterPerformItems" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import CompositionMultiFormModal from './../../../components/composition-multi-form-modal/CompositionMultiFormModal'
import moment from 'moment'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'CadriPage',
  components: { JtDynamicForm, page, CompositionMultiFormModal },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class CadriPage extends Vue {
  nmInterface = null;
  showMultiFormBoundResidues = false;
  formConfig = null;
  nrLinhaSelecionada = null;
  editMode = false;
  customCompositions = ['boundResidues']
  nonChangeableFields = []
  moment = moment

  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  get isAddNewGenerator () {
    return this.nmInterface === 'gravar'
  }

  get isEditGenerator () {
    return this.nmInterface === 'alterar'
  }

  get periodQuantity () {
    return this.forms[0]?.dadosForm?.periodQuantity
  }

  get endDate () {
    return this.forms[0]?.dadosForm?.endDate
  }

  get cadriEmission () {
    return this.forms[0]?.dadosForm?.cadriEmission
  }

  get landfill () {
    return this.forms[0]?.dadosForm?.landfill
  }

  prepareInputs (elements) {
    const inputs = elements[0].inputs
    this.prepareCompositionsInputs(inputs)
    return inputs
  }

  prepareCompositionsInputs (inputs) {
    inputs.forEach(input => {
      if (this.customCompositions.includes(input.model)) {
        input.allowCustomEditModal = true
      }
    })
  }

  onCompositionButtonClick (eventObject) {
    const { button: clickedButton } = eventObject

    switch (clickedButton.name) {
      case 'icAdicionarComposicao':
        this.addResidues(eventObject)
        break
      case 'icAlterarComposicao':
        this.editResidue(eventObject)
        break
      case 'icRemoveRecordOnComposition':
        this.removeResidue(eventObject)
        break
      default:
        break
    }
  }

  addResidues (eventObject) {
    this.editMode = false
    this.openMultiFormModal(eventObject)
  }

  editResidue (eventObject) {
    this.editMode = true
    this.nrLinhaSelecionada = eventObject.nrLinhaSelecionada
    this.openMultiFormModal(eventObject)
  }

  removeResidue (eventObject) {
    const { compositionId, params } = eventObject
    const clickedIndex = params && (params.__index || params.__index === 0) ? eventObject.params.__index : null
    const newResiduesArray = []
    this.elements[0].dadosForm[compositionId].forEach(residue => {
      const isAlreadyASavedRecord = residue.id || residue.id === 0
      if (isAlreadyASavedRecord || residue.__index !== clickedIndex) {
        residue.__index = newResiduesArray.length
        newResiduesArray.push(residue)

        if (residue.__index === clickedIndex && isAlreadyASavedRecord) {
          console.error('This button can\'t be used when the process is different from add a new generator')
        }
      }
    })
    this.elements[0].dadosForm[compositionId] = newResiduesArray
    this.nrLinhaSelecionada = null
  }

  openMultiFormModal (eventObject) {
    const { compositionId, formConfig } = eventObject

    if (this.customCompositions.includes(compositionId)) {
      this.formConfig = formConfig

      if (compositionId === 'boundResidues') {
        this.showMultiFormBoundResidues = true
      }

      this.$nextTick(() => {
        this.$refs[compositionId.substring(0, compositionId.length - 1)].show()
      })
    }
  }

  afterPerformItems () {
    this.showMultiFormBoundResidues = false
    this.$refs.boundResidue.hide()
  }

  @Watch('landfill')
  handleLandfillChange (newLandfillValue) {
    this.limparForm()
    this.forms[0].dadosForm.landfill = newLandfillValue
    this.setReadOnlyInput(!newLandfillValue, 'client')
  }

  @Watch('endDate')
  onEndDateChange () {
    this.handlePeriodQuantity()
  }

  handlePeriodQuantity () {
    if (this.endDate && this.cadriEmission) {
      const yearEndDate = this.moment(this.endDate, 'DD/MM/YYYY')
      const yearCadriEmission = this.moment(this.cadriEmission, 'DD/MM/YYYY')
      this.forms[0].dadosForm.periodQuantity = yearEndDate.diff(yearCadriEmission, 'years')
    }
  }

  @Watch('cadriEmission')
  onStartDateChange () {
    this.forms[0].dadosForm.startDate = this.forms[0]?.dadosForm?.cadriEmission
    this.handlePeriodQuantity()
  }
}
export default CadriPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.view-button-cadri {
  position: absolute;
  top: -46px;
  right: 14px;
  border-radius: 5px;
}
</style>
